import { render, staticRenderFns } from "./TipoRecebimento.vue?vue&type=template&id=7bc279d4&"
import script from "./TipoRecebimento.vue?vue&type=script&lang=js&"
export * from "./TipoRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports